/**
 * @name Session
 * @description A simple factory storing session data
 * @param {unknown} $log The angular log service
 * @param {unknown} $uibModal UI Bootstrap modal service
 * @param {unknown} $rootScope Angular rootScope service
 * @param {unknown} AUTH_EVENTS The auth events constant
 * @param {unknown} $interval Angular interval service
 * @param {service} AppVersion The AppVersion service
 * @param {constant} APP_VERSION The APP_VERSION constant
 * @param {library} _ The Lodash library
 * @return {object} Returns the Session object
 */
function Session(
  $log,
  $uibModal,
  $rootScope,
  AUTH_EVENTS,
  $interval,
  AppVersion,
  APP_VERSION,
  _
) {
  let Session = this;
  Session.mode = null;

  /**
   * @name Session.create
   * @description Creat a new session based on the JWT, roles, and collector
   * object
   * @param {string} token The token from the API
   * @param {array} roles An array of roles based on extended objects (artist,
   * operator) on collector
   * @param {object} collector The collector object. This conains all user
   * information
   */
  Session.create = function(token, roles, collector) {
    Session.token = token;
    Session.roles = roles;
    if (roles.indexOf('artist') !== -1) {
      Session.isArtist = true;
    }
    if (roles.indexOf('operator') !== -1) {
      Session.isOperator = true;
    }
    Session.collector = collector;
    if (collector.accepted_TOS_Privacy === false) {
      $uibModal.open({
        component: 'inkTerms',
        size: 'md',
        animation: true,
        backdrop: 'static',
        keyboard: false
      });
    }
    Session.acceptedTOSPrivacy = collector.accepted_TOS_Privacy;
    $log.debug('Session created for: ', Session.collector.email);

    Session.viewingMode = {
      calendarSkinny: collector.calendar_skinny,
      calendarCompact: collector.calendar_compact
    };
    $log.debug('Viewing mode: ', Session.viewingMode);

    Session.pollAppVersion = function() {
      Session.appVersionPoll = $interval(getAppVersion, 5000);
    };

    Session.cancelAppVersionPoll = function() {
      $interval.cancel(Session.appVersionPoll);
    };

    getAppVersion();
    Session.pollAppVersion();

    /**
     * @name checkAppVersion
     * @description Function to check the version of the app stored on the API
     */
    function getAppVersion() {
      AppVersion.get().then(function(appVersions) {
        let latestRelease = _.maxBy(appVersions, function(el) {
          return el.created;
        });
        if (latestRelease.app_version !== APP_VERSION) {
          $uibModal.open({
            component: 'inkAppVersion',
            size: 'lg',
            animation: true,
            backdrop: 'static',
            keyboard: false
          });
          return;
        }
        return;
      });
    }
  };

  /**
   * @name Session.destroy
   * @description Remove all values of the session
   */
  Session.destroy = function() {
    Session.token = null;
    Session.roles = null;
    Session.isArtist = null;
    Session.isOperator = null;
    Session.collector = null;
    Session.states = null;
    Session.activeState = null;
    $log.debug('Session destroyed');
  };

  /**
   * @name setState
   * @description Function to record all possible states of the logged in user.
   * @param {array} states An array of possible states for the logged in user.
   */
  Session.defineStates = function(states) {
    Session.states = states;
    $log.debug('Set states as: ', states);
  };

  /**
   * @name setActiveState
   * @description Function to set the active state of the logged in user.
   * The active state will determine the data sent by endpoints and interface
   * options.
   * @param {object} state The active state of the logged in user.
   */
  Session.setActiveState = function(state) {
    Session.activeState = state;
    $log.debug('Set active state as: ', state);
  };

  /**
   * @description This is being called from the Collector service when the
   * collector polling updates the collector.
   * @param {object} collector The collector object to update.
   */
  Session.updateCollector = function(collector) {
    Session.collector = collector;
    $rootScope.$broadcast(AUTH_EVENTS.collectorUpdated);
    $log.debug('Collector updated for: ', Session.collector);
  };

  return Session;
}

angular.module('inkfinder').factory('Session', Session);



// WEBPACK FOOTER //
// ./components/auth/session.service.js